
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'root': {'width': `100%`,'zIndex': `1`,'height': `100%`,'overflowY': `hidden`,},'appFrame': {'overflow': `hidden`,'display': `flex`,'width': `100%`,'height': `100%`,'flexDirection': `column`,},'content': {'minHeight': `calc(100vh - 100px)`,'position': `relative`,'flexGrow': `1`,'background': `'transparent'`,},'innerContent': {'marginTop': `100px`,'minHeight': `calc(100vh - 100px)`,'backgroundColor': `transparent`,'height': `100%`,'overflow': `hidden`,},'innerContentSidebar': {'marginTop': `0`,'marginLeft': `250px`,'minHeight': `calc(100% - 100px)`,'paddingTop': `36px`,'backgroundColor': `transparent`,},
        
      };
    };
  